import Swal from "sweetalert2";
import i18n from "src/i18n";

export const customAlert = ({
  title,
  html = "html",
}: {
  title?: string;
  html: string;
}) => {
  Swal.fire({
    title,
    html,
    text: "test",
    icon: "info",
    confirmButtonText: `${i18n.t("common.okBtn")}`,
    confirmButtonColor: "#2dd67c",
  });
};
